import { ServiceItem } from "./ServiceItem";
import { DefinitionItem } from "./DefinitionItem";
import { UserItem } from "./UserItem";
import { MonthPicker, UserProjectItem } from "./UserProjectItem";

export interface ProjectItem {
  id: string;
  projectStart: Date;
  projectStartPicker: MonthPicker;
  projectEnd: Date;
  projectEndPicker: MonthPicker;
  projectTypeId: number;
  projectType: string;
  projectName: string;
  projectNumber: string;
  invoiceTypeId: number;
  responsiblePerson: string;
  projectManager: string;
  nonBillableProjectType: number;
  nonBillableProjectTypeId: number;
  serviceId: number;
  service: ServiceItem | null;
  users: UserItem[];
  usersProject: UserProjectItem[];
  definitions: DefinitionItem[];
  description: string;
  getNonBillableProjectType: string;
  getProjectType: string;
  isDeleted: boolean;
  isCheckbox: boolean;
  isActive: boolean | null;
  isCustomActivity: boolean | null;
  // This property indicates whether the user assignment should be cut off when user assignment is out of project start/end period for this project.
  cutOffUserAssignment : boolean | null;
}

export enum ProjectType {
  Invoiced = 0,
  Internal = 1,
  NonBillable = 2,
  FloatingDays = 98,
  Vacation = 99,
}

export enum InvoiceType {
  Recovered = 0,
  CostCenter = 1,
}